// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5cabbb44","453":"6217e37f","455":"c780b3bc","977":"0f38bef7"}[chunkId] + ".chunk.js";
};